import { z } from 'zod';
export const lastNameSchema = z.string().meta({ autocomplete: 'family-name' });
